import { ApolloError, gql, useMutation } from "@apollo/client";
import { useCourieStore } from "@src/common/lib/store";
import { useErrorToast } from "@src/common/hooks/useErrorToast";

const ADD_END_CUSTOMER_COMMENT = gql`
  mutation AddEndCustomerComment(
    $courierId: ID!
    $endCustomerId: ID!
    $text: String!
  ) {
    addEndCustomerComment(
      courierId: $courierId
      endCustomerId: $endCustomerId
      text: $text
    ) {
      id
      text
      createdAt
      createdBy
    }
  }
`;

export function useAddComment(courierId: string, endCustomerId: string, onSuccess: () => void) {
  const showError = useErrorToast();
  const { showToast } = useCourieStore();
  const [addEndCustomerComment, { loading }] = useMutation(ADD_END_CUSTOMER_COMMENT);

  const addComment = (text: string): Promise<void> =>
    addEndCustomerComment({ variables: { courierId, endCustomerId, text } })
      .then(() => {
        showToast({ message: "Comment added", type: "success" });
        onSuccess();
      })
      .catch((error) => { showError(error as ApolloError); throw error; });

  return { addComment, loading };
}
